import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

export default function Header() {
  const [menu, setMenu] = useState(false);
  const location = useLocation();
  const closeFunc = (e) => {
    if (e.target === e.currentTarget) setMenu(false);
  };

  useEffect(() => {
    if (menu) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [menu]);

  useEffect(() => {
    setMenu(false);
    document.body.classList.remove("active");
  }, [location]);
  return (
    <div className="header">
      <div className="auto__container">
        <div className="header__inner">
          <Link to="" className="header__inner-logo">
            <img src={process.env.PUBLIC_URL + "/images/logo.svg"} alt="logo" />
          </Link>
          <nav className={"nav " + (menu ? "active" : "")} onClick={closeFunc}>
            <div className="nav__inner">
              <NavLink to="dashboard/invoice" className="nav__inner-link">
                Dashboard
              </NavLink>
              <NavLink to="dashboard/rewards" className="nav__inner-link">
                Rewards
              </NavLink>
              <NavLink to="dashboard/wallets" className="nav__inner-link">
                Wallets
              </NavLink>
              <NavLink to="dashboard/profile" className="nav__inner-link">
                Profile
              </NavLink>
              <NavLink to="dashboard/guides" className="nav__inner-link">
                Guides
              </NavLink>
            </div>
          </nav>
          <button className="button connect">Connect Wallet</button>
          <div
            className={"burger " + (menu ? "active" : "")}
            onClick={() => setMenu(!menu)}
          >
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
}
